import { MinimalProgressBar } from '@acorns/web-components'
import styled from 'styled-components'

import { style } from 'theme'

import { REFERRAL_BANNER_HEIGHT } from '../../ReferralBanner'
import { InnerProps, MiniNavProps } from './types'

export const MiniNavContainer = styled.div<Partial<InnerProps>>`
  align-items: center;
  background-color: #ffffff;
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.13), 0 1px 0 0 rgba(0, 0, 0, 0.04);
  display: ${props => (props.hideNav ? 'none' : 'flex')};
  flex-direction: column;
  height: 80px;
  justify-content: center;
  position: fixed;
  top: ${props => (props.hasBanner ? '44px' : '0')};
  left: 0;
  width: 100vw;
  z-index: 10;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    height: 70px;
  }
`

export const MiniNavShim = styled.div<Partial<MiniNavProps & InnerProps>>`
  background-color: transparent;

  height: ${props => {
      let shimHeight = props.hideNav ? 0 : 80
      shimHeight += props.hasBanner ? REFERRAL_BANNER_HEIGHT : 0
      shimHeight += props.noShim ? 0 : 40

      return shimHeight + 'px'
    }}
    @media (max-width: ${style(theme => theme.breakpoints.md)}px) {
    height: ${props => {
      let shimHeight = props.hideNav ? 0 : 80
      shimHeight += props.hasBanner ? REFERRAL_BANNER_HEIGHT : 0
      shimHeight += props.noShim ? 0 : 30

      return shimHeight + 'px'
    }};
  }

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    height: ${props => {
      let shimHeight = props.hideNav ? 0 : 70
      shimHeight += props.hasBanner ? REFERRAL_BANNER_HEIGHT : 0
      shimHeight += props.noShim ? 0 : 20

      return shimHeight + 'px'
    }};
  }
`

export const LogoContainer = styled.div`
  align-items: center;
  display: flex;
  flex-grow: 1;
  justify-content: center;
  width: 100%;
`

export const Logo = styled.img`
  width: 108px;
`

export const StyledMinimalProgressBar = styled(MinimalProgressBar)`
  align-self: baseline;
`

export const Link = styled.a`
  color: ${style(theme => theme.colors.green)};
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.57;
  position: absolute;
  right: 30px;
  text-decoration: none;
  outline: none;
  background: none;
  cursor: pointer;
  user-select: none;

  @media (max-width: ${style(theme => theme.breakpoints.md)}px) {
    right: 30px;
  }
  @media (max-width: 550px) {
    border: none;
    cursor: pointer;
    padding: 0;
    right: 20px;
    &:hover {
      background: none;
    }
  }
`
